import { render, staticRenderFns } from "./TenantCard.vue?vue&type=template&id=3134a1ce&"
import script from "./TenantCard.vue?vue&type=script&lang=js&"
export * from "./TenantCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports